/**
 * 资源管理相关
 */
import axios from "../../utils/axios";

// 添加市场分析asin
export function add_asin(data) {
    return axios({
        url: "/admin/market/analysis/add_asin",
        method: "POST",
        data: data
    });
}

// 市场分析asin列表
export function page_list(data) {
    return axios({
        url: "/admin/market/analysis/page_list",
        method: "POST",
        data: data
    });
}

// 市场分析关键词列表
export function keyword_list(data) {
    return axios({
        url: "/admin/market/analysis/keyword_list",
        method: "POST",
        data: data
    });
}

// 获取导出关键词列表链接
export function export_for_asin_list(data) {
    return axios({
        url: "/admin/market/analysis/export_for_asin_list",
        method: "POST",
        data: data
    });
}

// 删除市场分析关键词
export function del_keyword(data) {
    return axios({
        url: "/admin/market/analysis/del_keyword",
        method: "POST",
        data: data
    });
}
